module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pt-1"
  }, _vm._l((_vm.users), function(user) {
    return _c('v-list-tile', {
      key: user.uid,
      class: {
        'is_active': _vm.isActive(user)
      },
      attrs: {
        "avatar": "",
        "tag": "div"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeChannel(user)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": user.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      staticClass: "smaller__icon"
    }, [_c('v-icon', {
      class: {
        'success--text': _vm.isOnline(user), 'red--text': !_vm.isOnline(user)
      }
    }, [_vm._v("radio_button_checked")])], 1), _vm._v(" " + _vm._s(user.name) + " "), (_vm.getNotification(user) >= 1) ? _c('v-chip', {
      staticClass: "green lighten-2"
    }, [_vm._v(_vm._s(_vm.getNotification(user)))]) : _vm._e()], 1)], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010be8df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Users.vue
// module id = 216
// module chunks = 1